export const parseDateAsLocal = (date: string) => {
  const parts = date.split("-").map(p => parseInt(p));
  return new Date(parts[0], parts[1] - 1, parts[2]);
};
